import React from 'react';

const reviewList = [
  {
    name: 'Harleen Sethi',
    review:
      "I found myself overwhelmed by advice when I decided to go to Canada. Soo many consultancies that do this. But then I thought to myself, do what? I'll have to do everything myself anyway. Stamped's bundle is just the kind of thing that makes the journey smooth. A must buy!",
    full: 4,
    half: 1,
  },
  {
    name: 'Amrinder Singh Chatrath',
    review:
      "Got to know about Stamped through a colleague. I was a technical trainee doing 9-5 job, and I wanted to go to Canada but didn't know whether I would be able to continue education after gap or not. Chatting with their team clear all my doubts. Best regards.",
    full: 5,
    half: 0,
  },
  {
    name: 'Maya Chahal',
    review:
      "Normally I don't write reviews, but this calls for it. I literally had no idea what to do before reading their guide. Undoubtedly the best. Loved the folders and super simple intros.",
    full: 5,
    half: 0,
  },
  {
    name: 'Chandresh Shetty',
    review:
      "As students, we are told to have a very fixed view of what we can do but it's not the truth. I have been using Stamped's bundle for the past 2-3 months for my journey and now I'm looking forward to flying in a few days. Thanks for demystifying all this guys.",
    full: 5,
    half: 0,
  },
  {
    name: 'Ajooni Kaur',
    review:
      'I had a smooth experience with them. They are humble, informative and helpful people. I would definitely recommend to buy the Stamped Bundle for your journey. College Finder saved me so much time in research too.  Clear directions on what document are required and also gave me a clear route map of everything.',
    full: 4,
    half: 1,
  },
  {
    name: 'Gaurav Sharma',
    review:
      "Someone told me this is considered as best alternative to agent but I was skeptical at first so I went for both. Not only was Stamped more efficient in providing information but they helped me with other things I didn't expect as well. It is amazing how so many students are yet to find out this brilliant product. Extremely thankful.",
    full: 5,
    half: 0,
  },
  {
    name: 'Bhavya Shah',
    review:
      'Very systematic and easy to follow. I am very grateful to have found you, helped me in every sense. I appreciate you for your endeavor and salute for dedication to making the whole process smooth and helping students to reach their destinations.',
    full: 5,
    half: 0,
  },
  {
    name: 'Vishal Dutta',
    review:
      "I purchased this for my nephew and he was the only boy in his group who know what was going on throughout. Love the step by step in bundle because it give clear instruction on what to do when. Student don't have to be at mercy of someone's phone call to know. Really great. Cheers...!",
    full: 5,
    half: 0,
  },
  {
    name: 'Stuti Basak',
    review:
      "A hidden gem TBH. It's a very accessible resource and I'm glad I got it in time for my intake! The unambiguity and candor of their guide, and guidance, is an admirable thing. Before this, I paid a very famous consultancy 50k and it was an unmitigated disaster. My paramount concern after this was just finding accurate information and real help in a feasible way. Stamped really saved my day, and I hope that it saves yours too.",
    full: 5,
    half: 0,
  },
  {
    name: 'Monica Rodgrigues',
    review:
      'Stamped has really been a helpful and strong support to me, in terms of showing me the right path and clarifying so many doubts or questions that I may have had. at the end of the day, its about the information and the actual stuff you need like files or folders, which they more than take care of. Cant believe all of this was under 4k only!',
    full: 4,
    half: 1,
  },
];

const HalfStar = () => (
  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="18" height="18" viewBox="0 0 172 172">
    <defs>
      <linearGradient x1="107.63617" y1="10.9435" x2="21.63258" y2="143.90667" gradientUnits="userSpaceOnUse" id="color-1_zboVN5cCGojJ_gr1">
        <stop offset="0" stop-color="#e89e52"></stop>
        <stop offset="1" stop-color="#e89e52"></stop>
      </linearGradient>
    </defs>
    <g
      fill="none"
      fill-rule="nonzero"
      stroke="none"
      stroke-width="1"
      stroke-linecap="butt"
      stroke-linejoin="miter"
      stroke-miterlimit="10"
      stroke-dasharray=""
      stroke-dashoffset="0"
      font-family="none"
      font-weight="none"
      font-size="none"
      text-anchor="none"
    >
      <path d="M0,172v-172h172v172z" fill="none"></path>
      <g fill="url(#color-1_zboVN5cCGojJ_gr1)">
        <path d="M82.72842,18.57958l-19.6295,44.032l-47.93783,5.06325c-3.08167,0.32608 -4.32508,4.1495 -2.021,6.22425l35.80825,32.26792l-10.00108,47.16025c-0.64142,3.03508 2.60867,5.3965 5.29617,3.8485l41.75658,-24.08717v-116.63033c-1.32225,-0.00358 -2.64092,0.70592 -3.27158,2.12133z"></path>
      </g>
    </g>
  </svg>
);

const Star = () => (
  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="18" height="18" viewBox="0 0 172 172">
    <defs>
      <linearGradient x1="32.28225" y1="22.79" x2="136.49633" y2="162.20317" gradientUnits="userSpaceOnUse" id="color-1_8ggStxqyboK5_gr1">
        <stop offset="0" stop-color="#E89E52"></stop>
        <stop offset="1" stop-color="#E89E52"></stop>
      </linearGradient>
    </defs>
    <g
      fill="none"
      fill-rule="nonzero"
      stroke="none"
      stroke-width="1"
      stroke-linecap="butt"
      stroke-linejoin="miter"
      stroke-miterlimit="10"
      stroke-dasharray=""
      stroke-dashoffset="0"
      font-family="none"
      font-weight="none"
      font-size="none"
      text-anchor="none"
    >
      <path d="M0,172v-172h172v172z" fill="none"></path>
      <g fill="url(#color-1_8ggStxqyboK5_gr1)">
        <path d="M89.27158,18.58317l19.6295,44.032l47.93783,5.06325c3.08525,0.32608 4.32508,4.1495 2.021,6.22425l-35.80825,32.26792l10.00108,47.16025c0.645,3.03508 -2.60867,5.3965 -5.29617,3.8485l-41.75658,-24.09075l-41.75658,24.08717c-2.6875,1.548 -5.93758,-0.81342 -5.29617,-3.8485l10.00108,-47.16025l-35.80825,-32.26792c-2.30408,-2.07475 -1.06067,-5.89817 2.021,-6.22425l47.93783,-5.06325l19.6295,-44.032c1.26133,-2.83083 5.28183,-2.83083 6.54317,0.00358z"></path>
      </g>
    </g>
  </svg>
);

/*
This functions renders FULL STARS based on the passing function and the number.
*/
const RenderStars = ({ stars }) => {
  for (var i = 0; i < stars; i++) {
    return Array(stars).fill(<Star />);
  }
};

/*
This functions renders HALF STARS based on the passing function and the number.
*/
const RenderHalfStars = ({ stars }) => {
  if (stars === 0) {
    return null;
  }
  for (var j = 0; j < stars; j++) {
    return Array(stars).fill(<HalfStar />);
  }
};
const ReviewItem = ({ review }) => (
  <div
    id="review-outer"
    className="w-full p-8 m-2 text-left transition-all duration-500 cursor-pointer bg-darkAlt md:w-1/3 lg:w-1/4 hover:shadow-inner hover:bg-white"
  >
    <div className="flex space-x-1">
      <RenderStars stars={review.full} />
      <RenderHalfStars stars={review.half} />
    </div>
    <h3 className="mt-2 text-2xl font-bold text-gray-800 lg:text-2xl"> {review.name} </h3>
    <p className="text-sm text-gray-800">{review.review}</p>
  </div>
);

export default function ReviewSection({ total, title }) {
  return (
    <div className="w-full m-auto lg:my-24 lg:w-11/12">
      <div className="my-4 text-center">
        {title ? (
          <div>
            <h3 className="my-6 text-2xl font-bold text-center text-gray-800 lg:text-2xl"> Reviews </h3>
            <p className="text-gray-500"> Read what people are saying </p>
          </div>
        ) : (
          ''
        )}
      </div>
      <div id={'reviews-container'} className="flex flex-wrap justify-center w-full m-auto">
        {reviewList.map((review, i) => {
          if (i > total - 1) {
            return null;
          }
          return <ReviewItem review={review} />;
        })}
      </div>
    </div>
  );
}
